/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ILocation } from '../models/ILocation';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CoreLocationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ILocation
     * @throws ApiError
     */
    public getCoreLocationsIndex(): CancelablePromise<Array<ILocation>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/core/locations',
        });
    }

}
